import { useRouter } from 'next/router';
import React, { FC } from 'react';

import ArticlesCarousel from '@/components/articles-carousel/articles-carousel';
import Button from '@/components/button';
import { BLOG_HOME_PAGE } from '@/shared/constant';
import { Article } from '@/types/article';

import styles from './diji-blog-related-articles.module.scss';

export interface DijiBlogRelatedArticlesProps {
  articles?: Article[];
}

const DijiBlogRelatedArticles: FC<DijiBlogRelatedArticlesProps> = ({ articles }) => {
  const router = useRouter();

  if (!articles || articles.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.title}>More articles</div>
      <ArticlesCarousel
        articles={articles || []}
        ArticleCardProps={{
          dark: false,
        }}
      />
      <div className={styles.btnContainer}>
        <Button onClick={() => router.push(BLOG_HOME_PAGE)} className={styles.btn}>
          MORE POSTS
        </Button>
      </div>
    </div>
  );
};

export default DijiBlogRelatedArticles;
